import script from "./ConfigureMappingsStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigureMappingsStep.vue?vue&type=script&setup=true&lang=js"

import "./ConfigureMappingsStep.vue?vue&type=style&index=0&id=6c578fa4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c578fa4"]])

export default __exports__